import { Component, Input, inject } from '@angular/core';

import { ModalService } from '../../services';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-tooltip',
  styleUrls: ['tooltip.component.scss'],
  templateUrl: 'tooltip.component.html',
  imports: [NgbTooltip],
})
export class TooltipComponent {
  public readonly modalService = inject(ModalService);

  @Input() public title: string;
  @Input() public tooltip: string;
  @Input() public smallIcon = false;
  @Input() public showAsTooltip = false;
  @Input() public whiteIcon = false;

  public get id() {
    return this.title?.toLowerCase().replace(/ /g, '-') ?? 'notification-tooltip';
  }

  public openTooltip() {
    this.modalService.open({
      title: this.title,
      message: this.tooltip,
    });
  }
}
